import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { Transition } from '@headlessui/react';

// Layout Components
import Sidebar from './components/layout/Sidebar';
import Header from './components/layout/Header';

// Page Components
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Categories from './pages/Categories';
import PurchaseRecords from './pages/PurchaseRecords';
import InventoryChanges from './pages/InventoryChanges';
import Login from './pages/Login';
import Register from './pages/Register';

function App() {
  const [employee, setEmployee] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    // Try to load employee data from localStorage
    const savedEmployeeId = localStorage.getItem('employeeId');
    const savedEmployee = localStorage.getItem('employee');
    
    if (savedEmployeeId && savedEmployee) {
      try {
        const employeeData = JSON.parse(savedEmployee);
        setEmployee(employeeData);
      } catch (error) {
        console.error('Error parsing saved employee data:', error);
        // Clear invalid data
        localStorage.removeItem('employeeId');
        localStorage.removeItem('employee');
      }
    }
  }, []);

  const handleLogin = (data) => {
    setEmployee(data);
    // localStorage.setItem is handled in the Login component
  };

  const handleLogout = () => {
    setEmployee(null);
    localStorage.removeItem('employeeId');
    localStorage.removeItem('employee');
  };

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    if (!employee) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  // Layout Component
  const Layout = ({ children }) => {
    return (
      <div className="h-screen flex overflow-hidden bg-gray-100">
        {/* Sidebar */}
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

        {/* Main Content */}
        <div className="flex flex-col w-0 flex-1 overflow-hidden">
          <Header 
            sidebarOpen={sidebarOpen} 
            setSidebarOpen={setSidebarOpen}
            employee={employee}
            onLogout={handleLogout}
          />
          
          <main className="flex-1 relative overflow-y-auto focus:outline-none">
            <div className="py-6">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                {children}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  };

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={
            employee ? 
              <Navigate to="/" replace /> : 
              <Login onLogin={handleLogin} />
          } 
        />
        <Route 
          path="/register" 
          element={
            employee ? 
              <Navigate to="/" replace /> : 
              <Register onRegister={handleLogin} />
          } 
        />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory"
          element={
            <ProtectedRoute>
              <Layout>
                <Inventory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <ProtectedRoute>
              <Layout>
                <Categories />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-records"
          element={
            <ProtectedRoute>
              <Layout>
                <PurchaseRecords />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventory/changes"
          element={
            <ProtectedRoute>
              <Layout>
                <InventoryChanges />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App; 